export default [
  {
    path: 'contraches',
    name: 'employee_paycheck',
    component: () => import('./EmployeePaycheck.vue'),
    meta: {
      pageSection: 'Funcionários',
      pageTitle: 'Contracheques',
      auth: true,
      user: 'Admin',
    },
  },
]
